import createIcon from './createIcon';

/** 权益对比表「了解更多」：圆形容器 + 向下箭头（设计稿 容器.svg） */
export const CircleChevronDownIcon = createIcon('CircleChevronDown', (props) => {
  return (
    <svg {...props}>
      <g transform="matrix(0,1,-1,0,16,-16)">
        <path
          d="M23.4749999,6.6499996L23.999999,6.1249995L24.5249982,6.6499996L26.549999200000002,8.6749997L26.0249996,9.1999993L23.999999,7.1749988L21.974999,9.1999993L21.4499991,8.6749997L23.4749999,6.6499996ZM23.999999,14.374999C20.4749997,14.374999,17.625,11.5249987,17.625,7.999999C17.625,4.4749997,20.4749997,1.625,23.999999,1.625C27.524998699999998,1.625,30.374999000000003,4.4749997,30.374999000000003,7.999999C30.374999000000003,11.5249987,27.524998699999998,14.374999,23.999999,14.374999ZM23.999999,13.624998C27.0749998,13.624998,29.624997999999998,11.0749998,29.624997999999998,7.999999C29.624997999999998,4.9249992,27.0749998,2.37499982,23.999999,2.37499982C20.9249992,2.37499982,18.37499982,4.9249997,18.37499982,7.999999C18.37499982,11.0749979,20.9249997,13.624998,23.999999,13.624998Z"
          fill={props.color}
          fillOpacity="1"
        />
      </g>
    </svg>
  );
});

